// extracted by mini-css-extract-plugin
export default {"section":"section-3x4p7u","flush":"flush-1u_eK9","hasBorder":"hasBorder-17PTeu","subNavigation":"subNavigation-hLK_DJ"};